import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useState, useCallback } from 'react';
import Gallery from 'react-photo-gallery';
import { causesImages } from '../../assets/causes';
import pageHeader from '../../assets/images/pageHeader.a8555e51.jpg';

const Causes = () => {
  const { t } = useTranslation();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  // Transform images to react-photo-gallery format
  const photos = causesImages.map((image) => ({
    src: image.src,
    width: 4,
    height: 3,
    alt: image.alt,
    key: String(image.id)
  }));

  const openLightbox = useCallback((_event: any, { index }: { index: number }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <div className="causes-page">
      {/* Page Header */}
      <div
        className="page-header py-5"
        style={{
          backgroundImage: `url(${pageHeader})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <Container>
          <h1 className="text-white">{t('causes')}</h1>
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('causes')}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>

      {/* Gallery Section */}
      <Container className="my-5">
        <Row>
          <Col>
            <h2>Our Work in Haiti</h2>
            <p className="lead">
              Explore our various initiatives including church services, school programs,
              baptisms, and community events that help transform lives in Haiti.
            </p>
          </Col>
        </Row>

        <div className="mt-4">
          <Gallery photos={photos} onClick={openLightbox} />
        </div>
      </Container>

      {/* Lightbox Modal for Full-Size Image */}
      {viewerIsOpen && (
        <div
          className="image-modal"
          onClick={closeLightbox}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            cursor: 'pointer'
          }}
        >
          <div
            style={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%'
            }}
          >
            <img
              src={photos[currentImage].src}
              alt={photos[currentImage].alt}
              style={{
                maxWidth: '100%',
                maxHeight: '90vh',
                objectFit: 'contain'
              }}
            />
            <button
              onClick={(e) => {
                e.stopPropagation();
                setCurrentImage((currentImage - 1 + photos.length) % photos.length);
              }}
              style={{
                position: 'absolute',
                left: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.3)',
                border: 'none',
                color: 'white',
                fontSize: '30px',
                padding: '10px 20px',
                cursor: 'pointer',
                borderRadius: '5px'
              }}
            >
              &#8249;
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setCurrentImage((currentImage + 1) % photos.length);
              }}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.3)',
                border: 'none',
                color: 'white',
                fontSize: '30px',
                padding: '10px 20px',
                cursor: 'pointer',
                borderRadius: '5px'
              }}
            >
              &#8250;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Causes;
